import React from "react";
import { Col } from "antd";

export const FullWidthInputWrapper = ({ children, containerClass = '' }) => (
  <Col xs={24} className={`step-form-main-container align-self-end ${containerClass}`}>
    {children}
  </Col>
);
